"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconCalendar = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M11.59 14.93a1.76 1.76 0 0 1 1.76-1.76h43.3a1.76 1.76 0 0 1 1.76 1.76v8.78H47.87V22a1.76 1.76 0 1 0-3.51 0v1.76H25.64V22a1.76 1.76 0 1 0-3.51 0v1.76H11.59v-8.83zM54.9 57.07a1.76 1.76 0 0 1-1.76 1.76H16.86a1.76 1.76 0 0 1-1.76-1.76V27.22h7V29a1.76 1.76 0 1 0 3.51 0v-1.78h18.75V29a1.76 1.76 0 1 0 3.51 0v-1.78h7v29.85zM9.84 27.22h1.76v29.85a5.27 5.27 0 0 0 5.27 5.27h36.27a5.27 5.27 0 0 0 5.27-5.27V27.22h1.76a1.76 1.76 0 0 0 1.76-1.76V14.93a5.27 5.27 0 0 0-5.27-5.27H13.35a5.27 5.27 0 0 0-5.27 5.27v10.54a1.76 1.76 0 0 0 1.76 1.76z"
  }), _react["default"].createElement("path", {
    d: "M46.12 37.76a1.76 1.76 0 1 0 0-3.51h-7A1.76 1.76 0 0 0 37.34 36v7a1.76 1.76 0 0 0 1.76 1.76h3.51a1.76 1.76 0 0 1 0 3.51H39.1a1.76 1.76 0 0 0 0 3.51h3.51a5.27 5.27 0 0 0 0-10.53h-1.76v-3.49zM28.33 46.26c1.83-1.15 4.33-2.72 4.33-6.75a5.27 5.27 0 0 0-10.53 0 1.76 1.76 0 0 0 3.51 0 1.76 1.76 0 1 1 3.51 0c0 2-.87 2.63-2.69 3.77S22.13 46 22.13 50a1.76 1.76 0 0 0 1.76 1.76h7a1.76 1.76 0 0 0 0-3.51H26a6 6 0 0 1 2.33-2z"
  })),
  height: undefined,
  width: undefined
});
IconCalendar.displayName = 'IconCalendar';
var _default = IconCalendar;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/calendar.js
// module id = 221
// module chunks = 0